export const Nav = () => (
  <nav
    data-testid="main-nav"
    className="border-b border-cream px-6 md:px-12 py-5 flex items-center justify-between sticky top-0 bg-linen/90 backdrop-blur z-40"
  >
    <div className="flex items-center gap-3">
      <svg className="w-7 h-7 text-forest" viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M10 16c2-4 5-6 6-6s4 2 6 6-5 6-6 6-4-2-6-6z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="16" cy="16" r="2.5" fill="currentColor" />
      </svg>
      <div className="leading-tight">
        <span className="font-display text-lg tracking-tight font-semibold block text-ink">
          Elisabete Lopes
        </span>
        <span className="font-monolbl text-[10px] uppercase tracking-widest text-forest/80">
          LymphoMetabolic Academy
        </span>
      </div>
    </div>
    <div className="flex items-center gap-6">
      <a
        data-testid="nav-method-link"
        href="#method"
        className="text-xs uppercase tracking-wider text-moss hover:text-ink hidden md:inline transition-colors"
      >
        The Method
      </a>
      <a
        data-testid="nav-structure-link"
        href="#curriculum"
        className="text-xs uppercase tracking-wider text-moss hover:text-ink hidden md:inline transition-colors"
      >
        Structure
      </a>
      <a
        data-testid="nav-tuition-link"
        href="#pricing"
        className="text-xs uppercase tracking-wider text-moss hover:text-ink hidden md:inline transition-colors"
      >
        Tuition
      </a>
      <a
        data-testid="nav-enquire-button"
        href="#enquire"
        className="px-5 py-2.5 rounded-full bg-forest text-linen text-xs font-medium tracking-wide uppercase hover:bg-ink transition-colors"
      >
        Enquire Now
      </a>
    </div>
  </nav>
);
